/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Filter_FromInputs */

const vi_cashflow_filter_from = /** @type {(inputs: Cashflow_Filter_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ ngày`)
};

/**

* @param {Cashflow_Filter_FromInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_filter_from = /** @type {((inputs?: Cashflow_Filter_FromInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Filter_FromInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_filter_from(inputs)
});